import { Routes } from '@angular/router';

import { authGuard } from '@guards/auth.guard';
import { LoginComponent } from '../auth/components/login/login.component';
import { PwdRecoveryComponent } from '../auth/components/pwd-recovery/pwd-recovery.component';

export const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'pwd-recovery',
        component: PwdRecoveryComponent,
    },
    {
        canActivate: [authGuard],
        path: '', 
        loadChildren: () => import('../shell/routes'),
    },
  ];
